function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#369b75"
}, React.createElement("path", {
  d: "m362.67 106.67h-64c0-5.6602-2.25-11.086-6.25-15.086s-9.4258-6.25-15.086-6.25h-149.33v-10.664c0-5.8906-4.7773-10.668-10.668-10.668s-10.664 4.7773-10.664 10.668v352h-10.668c-5.8906 0-10.668 4.7734-10.668 10.664s4.7773 10.668 10.668 10.668h42.668c5.8906 0 10.664-4.7773 10.664-10.668s-4.7734-10.664-10.664-10.664h-10.668v-128h128c0 5.6562 2.2461 11.082 6.25 15.082 4 4.0039 9.4258 6.25 15.082 6.25h85.336c11.316 0 22.168-4.4961 30.168-12.496 8.0039-8.0039 12.496-18.855 12.496-30.172v-128c0-11.316-4.4922-22.168-12.496-30.168-8-8.0039-18.852-12.496-30.168-12.496zm21.332 85.332h-42.668v42.668h42.668v42.668l-42.668-0.003907v21.332l-42.664 0.003907v-21.336h-42.668v-42.664h-42.668v42.668l-42.664-0.003907v-42.664h-42.668v-42.668h42.668v-42.668h-42.668v-42.664h42.668v42.664h42.668l-0.003907-42.664h42.668v42.664h42.668v-21.332h42.668l-0.003907 21.332h42.668z"
}), React.createElement("path", {
  d: "m170.67 192h42.668v42.668h-42.668z"
}), React.createElement("path", {
  d: "m213.33 149.33h42.668v42.668h-42.668z"
}), React.createElement("path", {
  d: "m256 192h42.668v42.668h-42.668z"
}), React.createElement("path", {
  d: "m298.67 149.33h42.668v42.668h-42.668z"
}), React.createElement("path", {
  d: "m298.67 234.67h42.668v42.668h-42.668z"
}));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    version: 1.1,
    viewBox: "0 0 512 512"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/opp-goal.16088a5e.svg";
export { SvgComponent as ReactComponent };